module.exports = __webpack_public_path__ + "static/media/frame.9ca49d42.svg";